import { COLOR_BLACK, COLOR_BRAND_ORANGE_300, COLOR_BRAND_ORANGE_500, COLOR_BRAND_ORANGE_700, COLOR_BRAND_WHITE, COLOR_GRAY_00, COLOR_GRAY_100, COLOR_GRAY_200, COLOR_GRAY_400, COLOR_GRAY_600, COLOR_PRIMARY_ORANGE_00, COLOR_PRIMARY_ORANGE_100, COLOR_PRIMARY_ORANGE_300, COLOR_PRIMARY_ORANGE_500, COLOR_PRIMARY_ORANGE_700, COLOR_SECONDARY_BLUE_00, COLOR_SECONDARY_BLUE_100, COLOR_SECONDARY_BLUE_300, COLOR_SECONDARY_BLUE_500, COLOR_SECONDARY_BLUE_700, COLOR_SECONDARY_GREEN_00, COLOR_SECONDARY_GREEN_100, COLOR_SECONDARY_GREEN_300, COLOR_SECONDARY_GREEN_500, COLOR_SECONDARY_GREEN_700, COLOR_SECONDARY_PURPLE_00, COLOR_SECONDARY_PURPLE_100, COLOR_SECONDARY_PURPLE_300, COLOR_SECONDARY_PURPLE_500, COLOR_SECONDARY_PURPLE_700, COLOR_TRANSPARENT, COLOR_WHITE, } from '../../../themes/InaccessibleLight/colors.values';
export function getBackgroundColor(transformer) {
    return Object.freeze({
        transparent: transformer.backgroundColor(COLOR_TRANSPARENT),
        black: transformer.backgroundColor(COLOR_BLACK),
        white: transformer.backgroundColor(COLOR_WHITE),
        gray00: transformer.backgroundColor(COLOR_GRAY_00),
        gray100: transformer.backgroundColor(COLOR_GRAY_100),
        gray200: transformer.backgroundColor(COLOR_GRAY_200),
        gray400: transformer.backgroundColor(COLOR_GRAY_400),
        gray600: transformer.backgroundColor(COLOR_GRAY_600),
        brand: {
            white: transformer.backgroundColor(COLOR_BRAND_WHITE),
            orange00: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_00),
            orange300: transformer.backgroundColor(COLOR_BRAND_ORANGE_300),
            orange500: transformer.backgroundColor(COLOR_BRAND_ORANGE_500),
            orange700: transformer.backgroundColor(COLOR_BRAND_ORANGE_700),
        },
        primary: {
            orange00: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_00),
            orange100: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_100),
            orange300: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_300),
            orange500: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_500),
            orange700: transformer.backgroundColor(COLOR_PRIMARY_ORANGE_700),
        },
        secondary: {
            blue00: transformer.backgroundColor(COLOR_SECONDARY_BLUE_00),
            blue100: transformer.backgroundColor(COLOR_SECONDARY_BLUE_100),
            blue300: transformer.backgroundColor(COLOR_SECONDARY_BLUE_300),
            blue500: transformer.backgroundColor(COLOR_SECONDARY_BLUE_500),
            blue700: transformer.backgroundColor(COLOR_SECONDARY_BLUE_700),
            green00: transformer.backgroundColor(COLOR_SECONDARY_GREEN_00),
            green100: transformer.backgroundColor(COLOR_SECONDARY_GREEN_100),
            green300: transformer.backgroundColor(COLOR_SECONDARY_GREEN_300),
            green500: transformer.backgroundColor(COLOR_SECONDARY_GREEN_500),
            green700: transformer.backgroundColor(COLOR_SECONDARY_GREEN_700),
            purple00: transformer.backgroundColor(COLOR_SECONDARY_PURPLE_00),
            purple100: transformer.backgroundColor(COLOR_SECONDARY_PURPLE_100),
            purple300: transformer.backgroundColor(COLOR_SECONDARY_PURPLE_300),
            purple500: transformer.backgroundColor(COLOR_SECONDARY_PURPLE_500),
            purple700: transformer.backgroundColor(COLOR_SECONDARY_PURPLE_700),
        },
    });
}
